import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ReportsTemplatesComponent, ReportTemplateUI } from '@src/app/modules/reports-templates';

@Component({
  selector: 'report-templates',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule, ReportsTemplatesComponent],
  templateUrl: './templates.component.html',
  styleUrl: './templates.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemplatesComponent {
  @Input() selectedItem?: ReportTemplateUI;
  @Output() accept = new EventEmitter<ReportTemplateUI>();
  @Output() reject = new EventEmitter<void>();

  visible = true;

  onAccept() {
    this.accept.emit(this.selectedItem);
  }

  onClose() {
    this.reject.emit();
  }

  onChangeVisible(visible: boolean) {
    if (!visible) {
      this.onClose();
    }
  }

  selectionChange(value: ReportTemplateUI[]) {
    this.selectedItem = value[0];
  }
}
